import i18n from 'i18next';
import abTranslate from 'ab-translate/dist/src/abTranslate-runtime';
let loaded = false;
let instance;
let promise;
export function i18nInit({ locale, experiments = {} }) {
    if (loaded) {
        return instance;
    }
    if (!promise) {
        instance = i18n.createInstance();
        instance.use({
            type: 'backend',
            read: (language, namespace, callback) => {
                return import(`./locales/messages_${language}.json`)
                    .then((translation) => callback(null, abTranslate(experiments.experiments, translation)))
                    .catch((error) => callback(error));
            },
        });
        promise = instance
            .init({
            lng: locale,
            fallbackLng: 'en',
            keySeparator: false,
            backend: {
                loadPath: `./locales/messages_${locale}.json`,
                crossDomain: true,
                parse: (translations) => {
                    try {
                        return abTranslate(experiments, JSON.parse(translations));
                    }
                    catch (e) {
                        return JSON.parse(translations);
                    }
                },
            },
        })
            .then(() => (loaded = true))
            .catch(console.error);
    }
    return instance;
}
//# sourceMappingURL=i18n.js.map